import Request from 'components/Request';
import { csrfParameters } from 'react/settings/account/accountDeletionRequests';
import { formatDate } from 'i18n/locale';

// Calls to the account_settings/* domain endpoints. Failures reject with
// the jQuery xhr, whose responseJSON carries { error } or { errors: { field } }.
const post = (action, parameters = {}) => Promise.resolve(Request.apiv1Post(`account_settings/${action}`, { ...parameters, ...csrfParameters() }));

export const fetchOverview = () => Promise.resolve(Request.apiv1Get('account_settings/overview'));

export const saveSignInDetails = ({ currentPassword, email, newPassword, confirmNewPassword }) => post('login', {
	current_password: currentPassword,
	email,
	new_password: newPassword,
	confirm_new_password: confirmNewPassword,
});

// Resolves with { has_password, login_methods: { password: { is_set }, providers: [...] } }.
export const fetchLoginMethods = () => Promise.resolve(Request.apiv1Get('account_settings/login_methods'));

// Needs a fresh re-auth or currentPassword. Resolves with { success, login_methods }.
export const unlinkLoginMethod = ({ provider, currentPassword = '' }) => post('unlink_login_method', {
	provider,
	current_password: currentPassword,
});

export const endSession = (sessionId) => post('end_session', { session_id: sessionId });

export const endOtherSessions = () => post('end_other_sessions');

export const revokeApp = (tokenId) => post('revoke_app', { token_id: tokenId });

// Partial update; resolves with the updated preferences object.
export const savePreferences = (changes) => post('preferences', changes)
	.then((response) => (response && response.preferences) || response);

// Partial update of what the profile Overview shows: { show_recent_matches }
// or { ladder_id, game_shown }, booleans as 1/0. Resolves with the updated
// { show_recent_matches, games: [{ ladder_id, name, shown }] }.
export const saveProfileVisibility = (changes) => post('profile_visibility', changes)
	.then((response) => (response && response.profile_visibility) || response);

// Partial update of the match history display settings ({ show_results },
// { featured_ladder_id }, ...), booleans as 1/0. Resolves with the updated
// settings as account_settings/overview's history_display has them.
export const saveHistoryDisplay = (changes) => post('history_display', changes)
	.then((response) => (response && response.history_display) || response);

const dateFormat = { year: 'numeric', month: 'short', day: 'numeric' };

export const formatSettingsDate = (isoDate) => {
	if(!isoDate) {
		return '';
	}
	const date = new Date(isoDate);
	if(Number.isNaN(date.getTime())) {
		return '';
	}
	return formatDate(date, dateFormat);
};
